enum AgentCreationStep {
  ASSISTANT = 'assistant',
  BEHAVIOR = 'behavior',
  KNOWLEDGE = 'knowledge',
  CAPABILITIES = 'capabilities',
  ANALYTICS = 'analytics',
  LINE = 'line',
}

export default AgentCreationStep;
